import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Paper, Box } from '@mui/material'

import { ApplicationState } from '@/state/root.models'
import {
  UiFeedbackComponent,
  SportsROCalculatorTableComponent,
  SportsROCalculatorFiltersComponent,
} from './components'
import { useSportsROCalculatorActions } from './hooks'

const SportROCalculatorModule = () => {
  const { setSportsROCalculatorFilters, cleanSportsRO } =
    useSportsROCalculatorActions()

  const { brand } = useSelector(({ auth }: ApplicationState) => auth)

  useEffect(() => {
    return () => {
      cleanSportsRO()
      setSportsROCalculatorFilters({
        page: 1,
        limit: 25,
      })
    }
  }, [brand]) // eslint-disable-line

  return (
    <Box
      component={Paper}
      minHeight="calc(100vh - 168px)"
      display="flex"
      flexDirection="column"
      borderRadius={2}
    >
      <Box p={2}>
        <SportsROCalculatorFiltersComponent />
      </Box>
      <SportsROCalculatorTableComponent />
      <UiFeedbackComponent />
    </Box>
  )
}

export default SportROCalculatorModule
